// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-receptionist",
 "roleDisplay": "AI Receptionist",
 "phrase": "ai receptionist",
 "seo": {
  "title": "AI Receptionist: Answers Calls and Email | CellCog",
  "description": "An AI receptionist with their own phone number: they answer calls and emails, handle common questions from your docs, book appointments and flag the rest."
 },
 "painSub": "Every missed call is a customer who tried someone else. Your AI receptionist picks up on their own number, answers from your real information, books the appointment and tells you what needs you.",
 "definition": "An AI receptionist is an AI employee that answers phone calls and emails, handles common questions from your documents, books appointments and transfers calls that need a person to you. On CellCog an AI receptionist is hired in minutes, with their own inbox and their own phone number, a capability CellCog shipped in September 2026.",
 "panes": [
  {
   "num": "01 · CALLS",
   "title": "Answers every call.",
   "sub": "Their own number, their own voice. Each call is transcribed with a short summary.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--calllog\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Calls</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Calls today</b><span>Lumen Dental Studio</span></div><div class=\"rf-counts\"><span class=\"rf-count rf-tone-accent\"><b>14</b> answered</span><span class=\"rf-count rf-tone-green\"><b>6</b> booked</span><span class=\"rf-count rf-tone-purple\"><b>1</b> transferred</span></div><ul class=\"rf-calls rf-panel\"><li class=\"rf-call\"><span class=\"rf-callic rf-tone-green\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"/></svg></span><div class=\"rf-call-m\"><div class=\"rf-call-top\"><b>Nora Briggs</b><span>8:04 am · 3 min</span></div><p>New patient cleaning, Thu 10:00. Insurance details saved.</p></div><span class=\"rf-chip rf-tone-green\">Booked</span></li><li class=\"rf-call\"><span class=\"rf-callic rf-tone-blue\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"/></svg></span><div class=\"rf-call-m\"><div class=\"rf-call-top\"><b>Oakview Clinic</b><span>8:31 am · 2 min</span></div><p>Asked for X-rays for a shared patient. Sent to your inbox.</p></div><span class=\"rf-chip rf-tone-blue\">Message</span></li><li class=\"rf-call\"><span class=\"rf-callic rf-tone-amber\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"/></svg></span><div class=\"rf-call-m\"><div class=\"rf-call-top\"><b>Ben Alvarez</b><span>9:15 am · 4 min</span></div><p>Filling moved from Mon to Wed 2:30. Confirmation emailed.</p></div><span class=\"rf-chip rf-tone-amber\">Moved</span></li><li class=\"rf-call\"><span class=\"rf-callic rf-tone-purple\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"/></svg></span><div class=\"rf-call-m\"><div class=\"rf-call-top\"><b>Grace Kim</b><span>10:02 am · 1 min</span></div><p>Tooth pain since last night. Put through to you for same-day advice.</p></div><span class=\"rf-chip rf-tone-purple\">Transferred</span></li><li class=\"rf-call\"><span class=\"rf-callic rf-tone-green\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z\"/></svg></span><div class=\"rf-call-m\"><div class=\"rf-call-top\"><b>Leo Hart</b><span>11:40 am · 2 min</span></div><p>Whitening consult, Fri 4:00. Asked about aftercare, answered.</p></div><span class=\"rf-chip rf-tone-green\">Booked</span></li></ul></div></div></div>"
  },
  {
   "num": "02 · BOOKINGS",
   "title": "Books the appointment.",
   "sub": "They check your calendar, offer open times and send the confirmation.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--calendar\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Bookings</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Bookings, week of Oct 12</b><span>17 visits, one emergency slot kept open</span></div><div class=\"rf-week\"><div class=\"rf-wcol\"><span class=\"rf-wday\">Mon 12</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">8:00</span><b>Cleaning, K. Ward</b></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">9:30</span><b>Filling, J. Soto</b></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">11:00</span><b>New patient exam</b><em>Forms sent</em></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">2:30</span><b>Crown fitting</b></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Tue 13</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">8:30</span><b>Cleaning, R. Diaz</b></div><div class=\"rf-wev rf-tone-cyan\"><span class=\"rf-wev-time\">10:00</span><b>Whitening consult</b></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">1:00</span><b>Kids checkup</b><em>Two siblings</em></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">3:30</span><b>Root canal</b></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Wed 14</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">9:00</span><b>Cleaning, A. Moss</b></div><div class=\"rf-wev rf-tone-amber\"><span class=\"rf-wev-time\">11:30</span><b>Emergency slot</b><em>Kept open</em></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">2:30</span><b>Filling, B. Alvarez</b><em>Moved from Mon</em></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Thu 15</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">8:00</span><b>Cleaning, T. Ng</b></div><div class=\"rf-wev rf-tone-green\"><span class=\"rf-wev-time\">10:00</span><b>New patient, N. Briggs</b><em>Booked by phone</em></div><div class=\"rf-wev rf-tone-cyan\"><span class=\"rf-wev-time\">1:30</span><b>Implant consult</b></div><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">4:00</span><b>Cleaning, S. Lowe</b></div></div><div class=\"rf-wcol\"><span class=\"rf-wday\">Fri 16</span><div class=\"rf-wev rf-tone-blue\"><span class=\"rf-wev-time\">9:00</span><b>Cleaning, P. Grant</b></div><div class=\"rf-wev rf-tone-purple\"><span class=\"rf-wev-time\">11:00</span><b>Retainer check</b></div><div class=\"rf-wev rf-tone-cyan\"><span class=\"rf-wev-time\">4:00</span><b>Whitening, L. Hart</b><em>Booked by phone</em></div></div></div><div class=\"rf-sched\"><div class=\"rf-sched-wk\">Mon 12</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-sched-row--time rf-tone-blue\"><span class=\"rf-sched-time\">8:00</span><span class=\"rf-sched-t\">Cleaning, K. Ward</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-purple\"><span class=\"rf-sched-time\">9:30</span><span class=\"rf-sched-t\">Filling, J. Soto</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-green\"><span class=\"rf-sched-time\">11:00</span><span class=\"rf-sched-t\">New patient exam</span><span class=\"rf-sched-c\">Forms sent</span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-purple\"><span class=\"rf-sched-time\">2:30</span><span class=\"rf-sched-t\">Crown fitting</span><span class=\"rf-sched-c\"></span></li></ul><div class=\"rf-sched-wk\">Tue 13</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-sched-row--time rf-tone-blue\"><span class=\"rf-sched-time\">8:30</span><span class=\"rf-sched-t\">Cleaning, R. Diaz</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-cyan\"><span class=\"rf-sched-time\">10:00</span><span class=\"rf-sched-t\">Whitening consult</span><span class=\"rf-sched-c\"></span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-green\"><span class=\"rf-sched-time\">1:00</span><span class=\"rf-sched-t\">Kids checkup</span><span class=\"rf-sched-c\">Two siblings</span></li><li class=\"rf-sched-row rf-sched-row--time rf-tone-purple\"><span class=\"rf-sched-time\">3:30</span><span class=\"rf-sched-t\">Root canal</span><span class=\"rf-sched-c\"></span></li></ul><p class=\"rf-sched-more\">and 10 more this week</p></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Knows your business.",
   "sub": "Hours, services, policies and FAQs live in your Drive. Your AI receptionist answers from them, not from guesses.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Lumen Dental</span><i aria-hidden=\"true\">/</i><b>Front desk</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Services and visit lengths.docx</span><span class=\"rf-fmeta\">What each visit needs</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Insurance we accept.pdf</span><span class=\"rf-fmeta\">12 plans</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-xls\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M8 13h2\"/><path d=\"M14 13h2\"/><path d=\"M8 17h2\"/><path d=\"M14 17h2\"/></svg><span class=\"rf-sr\">Spreadsheet</span></span><span class=\"rf-fname\">Patient FAQ.xlsx</span><span class=\"rf-fmeta\">64 answers</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Call notes</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Tooth pain calls come straight to you, new patients get forms by email, and Wednesday 11:30 stays open for emergencies.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before anything unusual.",
   "sub": "Refunds, exceptions and new commitments wait for your yes.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Send this reply to Nora Briggs?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/gmail\" alt=\"\" width=\"16\" height=\"16\"><span>Gmail</span><em>To: Nora Briggs</em></div><b class=\"rf-prev-t\">Your visit on Thursday</b><p class=\"rf-prev-b\">Hi Nora, you are booked for a cleaning on Thursday at 10:00. Your new patient forms are attached, and parking is free behind the building.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Reminder emails for tomorrow&#x27;s 9 visits</span><span class=\"rf-q-m\">Gmail · ready</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Call back Oakview Clinic about X-rays</span><span class=\"rf-q-m\">Phone · after 2:00</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Tells you who called.",
   "sub": "Who got in touch, what they needed, what is booked and which calls need you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Front desk today</b><span>Today, 5:30 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>14</b><span>calls answered</span></div><div class=\"rf-stat\"><b>6</b><span>visits booked</span></div><div class=\"rf-stat\"><b>1</b><span>transferred</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Answered 14 calls and booked 6 visits</li><li>Moved 2 appointments, nobody double booked</li><li>Put Grace Kim&#x27;s call through to you</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Send reminders for tomorrow&#x27;s visits</li><li>Confirm the Friday whitening slots</li><li>Follow up on 2 unreturned forms</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Approve the new patient welcome email</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Answers calls on their own number",
   "body": "Picks up with their own voice and tells callers they are speaking with an AI employee."
  },
  {
   "title": "Replies to email",
   "body": "Answers routine questions from your inbox the same way they answer the phone."
  },
  {
   "title": "Books appointments",
   "body": "Checks the calendar you connect, offers open times and sends the confirmation."
  },
  {
   "title": "Answers from your documents",
   "body": "Hours, services and policies come only from what you upload."
  },
  {
   "title": "Transfers calls to you",
   "body": "When a caller needs a person right away, your AI receptionist puts the call through to your number."
  },
  {
   "title": "Summarizes every call",
   "body": "A transcript and a short summary for each call, so nothing is lost between calls."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a receptionist for our dental practice. Answer calls and book cleanings.\""
  },
  {
   "n": "02",
   "title": "Give them your answers.",
   "body": "Upload your hours, services and FAQs, and connect the calendar they book into."
  },
  {
   "n": "03",
   "title": "Choose their phone number.",
   "body": "Pick a number on your yes and share it with your customers."
  }
 ],
 "tools": [
  {
   "name": "Google Calendar",
   "logo": "https://logos.composio.dev/api/googlecalendar"
  },
  {
   "name": "Gmail",
   "logo": "https://logos.composio.dev/api/gmail"
  },
  {
   "name": "Outlook",
   "logo": "https://logos.composio.dev/api/outlook"
  },
  {
   "name": "Calendly",
   "logo": "https://logos.composio.dev/api/calendly"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  },
  {
   "name": "HubSpot",
   "logo": "https://logos.composio.dev/api/hubspot"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  }
 ],
 "control": {
  "statement": "Nothing is promised without your yes.",
  "sub": "They handle the routine.",
  "accent": "You decide the exceptions.",
  "rows": [
   {
    "title": "Answers from your documents",
    "body": "What they say comes from the information you gave them."
   },
   {
    "title": "Exceptions come to you",
    "body": "Refunds, special requests and anything new wait for your yes."
   },
   {
    "title": "Every call on record",
    "body": "Recorded and transcribed, with a summary you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They run your front desk.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "One call at a time",
    "body": "A second caller hears busy until the line frees up."
   },
   {
    "title": "No texting",
    "body": "They answer calls and email; text messages are not supported."
   },
   {
    "title": "No made-up answers",
    "body": "What isn't in your documents goes to you, not to the caller as a guess."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to cover the front desk",
  "cols": [
   "Doing it yourself",
   "An answering service",
   "AI Receptionist"
  ],
  "rows": [
   {
    "label": "Answers calls",
    "cells": [
     "Between other work",
     "Yes, from a script",
     "Yes, from your documents"
    ]
   },
   {
    "label": "Books appointments",
    "cells": [
     "You",
     "Takes a message",
     "Books into your calendar"
    ]
   },
   {
    "label": "Replies to email",
    "cells": [
     "You",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Summarizes each call",
    "cells": [
     "No",
     "A message slip",
     "Transcript and summary"
    ]
   },
   {
    "label": "Takes two calls at once",
    "cells": [
     "No",
     "Yes",
     "Not yet, one at a time"
    ]
   },
   {
    "label": "Transfers urgent calls",
    "cells": [
     "n/a",
     "Yes",
     "Yes, to your number"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Here are 15 questions customers ask us most. Write clear, friendly answers based on our docs and format them as a customer-facing FAQ page.",
   "deliverable": "a formatted FAQ document"
  },
  {
   "q": "Draft polite email responses for these five common situations: refund request, hours inquiry, booking change, complaint, and partnership ask.",
   "deliverable": "five reusable email templates"
  },
  {
   "q": "Summarize these 30 incoming messages by priority and tell me which three need a same-day reply.",
   "deliverable": "a prioritized inbox summary"
  },
  {
   "q": "Create a simple intake form for new client inquiries with the fields we need to route them correctly.",
   "deliverable": "a ready-to-use intake form"
  },
  {
   "q": "Write appointment confirmation and reminder messages for our booking flow, friendly and on brand.",
   "deliverable": "confirmation and reminder templates"
  }
 ],
 "faq": [
  {
   "q": "What is an AI receptionist?",
   "a": "An AI receptionist is an AI employee that answers phone calls and emails, handles common questions from your documents, books appointments and transfers calls that need a person to you."
  },
  {
   "q": "Can they answer phone calls?",
   "a": "Yes. They get their own phone number and answer every call with their own voice. Callers are told they are speaking with an AI employee at your business, and every call is recorded and transcribed for you."
  },
  {
   "q": "What happens when they don't know an answer?",
   "a": "They say they will check, and flag the call or email for you instead of inventing an answer. When a caller needs a person right away, your AI receptionist can transfer the call to your own number."
  },
  {
   "q": "Can they book appointments?",
   "a": "Yes. They check the calendar you connect, offer open times, book the slot and send the confirmation."
  },
  {
   "q": "Is an AI virtual receptionist the same thing?",
   "a": "Yes. An AI virtual receptionist answers your calls and messages remotely; on CellCog they also handle your email and keep a task board of what they did."
  },
  {
   "q": "Can they take two calls at once?",
   "a": "No. They take one call at a time, and a second caller hears busy. For a front desk that gets several calls at the same moment, plan for that."
  },
  {
   "q": "Are they an AI voice receptionist?",
   "a": "Yes. Callers talk to your AI receptionist in a natural voice on the receptionist's own phone number. The receptionist tells them they are speaking with an AI, answers from your documents and transfers urgent calls to you."
  },
  {
   "q": "Is an AI receptionist a good fit for a small business?",
   "a": "Yes. They are built for businesses where the person who should answer the phone is busy doing the work. Your AI receptionist answers on their own number and sends you a summary of every call they take."
  },
  {
   "q": "Can I try an AI receptionist for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI receptionist and try a first task."
  },
  {
   "q": "What does an AI receptionist cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Receptionist in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Receptionist to work today",
  "body": "Give them your most common customer questions and get back a clean, friendly FAQ you can publish today."
 },
 "audience": {
  "title": "Who hires an AI phone receptionist",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "A front desk for a business of one",
    "body": "Calls answered on your AI receptionist's own number while you are with a client, with a summary of each call after."
   },
   {
    "badge": "Small businesses",
    "title": "Calls answered while you work",
    "body": "Owners who miss calls during the day get a receptionist who answers on their own number, handles what they can and puts urgent calls through."
   },
   {
    "badge": "Mid-size companies",
    "title": "A second line for the front desk",
    "body": "Your AI receptionist answers their own number when the desk is busy or closed, from your documents, and transfers urgent calls."
   },
   {
    "badge": "Agencies",
    "title": "A receptionist for each client",
    "body": "Agencies that run front desks for clients hire one per client, each with their own number and answers."
   },
   {
    "badge": "Dental and medical practices",
    "title": "Calls handled between patients",
    "body": "Your AI receptionist answers questions about hours and services, then books, moves or cancels the appointment."
   },
   {
    "badge": "Home services",
    "title": "Jobs caught, not lost to voicemail",
    "body": "Plumbers, electricians and cleaners get the caller's details taken and the visit booked while they are on a job."
   }
  ]
 }
};

export default content;
